import React, { useEffect, useRef } from 'react'
import { JobLifecycle } from 'types/jobLifecycle'
import styles from './job-status.module.scss'

export default function JobStatus({ jobStatus }) {
    const { status, messages } = jobStatus
    const messagesContainerRef = useRef<HTMLDivElement | null>(null)

    useEffect(() => {
        const container = messagesContainerRef.current
        if (!container) return

        // Delay scrolling slightly to avoid interfering with outer containers
        const id = window.setTimeout(() => {
            // Scroll only the local container to bottom
            try {
                container.scrollTo({ top: container.scrollHeight, behavior: 'smooth' })
            } catch (_e) {
                // Fallback without smooth behavior
                container.scrollTop = container.scrollHeight
            }
        }, 100)

        return () => window.clearTimeout(id)
    }, [messages?.length])

    return (
        <div className={styles.jobStatusContainer}>
            <div className={styles.jobStatusContent}>
                <div className={styles.spinnerContainer}>
                    <div>
                        {status === JobLifecycle.FINISHED && (
                            <i className={`fa fa-check fa-lg ${styles.finishedIcon}`} />
                        )}
                        {status === JobLifecycle.FAILED && (
                            <i className={`fa fa-times fa-lg ${styles.failedIcon}`} />
                        )}
                        {status === JobLifecycle.STARTED && (
                            <i
                                className={`fa fa-circle-o-notch fa-spin fa-lg ${styles.spinningIcon}`}
                            />
                        )}
                    </div>
                </div>
                <div className={styles.messagesContainer} ref={messagesContainerRef}>
                    {messages &&
                        messages.map((msg, index) => (
                            <div
                                key={index}
                                className={`${styles.message} ${
                                    status === JobLifecycle.FAILED ? styles.errorMessage : ''
                                }`}
                                title={msg}
                            >
                                {msg}
                            </div>
                        ))}
                </div>
            </div>
        </div>
    )
}
